import { createFileRoute } from '@tanstack/react-router';

import { createQueryLoader } from '@/loader';
import StartSubmissionPageQueryNode, {
  type StartSubmissionPageQuery,
} from '@/pages/start/__generated__/StartSubmissionPageQuery.graphql';
import StartSubmissionPage from '@/pages/start/StartSubmissionPage';

const loadSubmission = createQueryLoader<StartSubmissionPageQuery>(
  StartSubmissionPageQueryNode,
);

export const Route = createFileRoute('/_authenticated/start/$submissionId/')({
  loader: ({ context, params }) =>
    loadSubmission({
      environment: context.relayEnvironment,
      variables: { submissionId: params.submissionId },
    }),
  component: StartSubmissionPage,
  shouldReload: false,
});
